import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function FAQ({ items, title = "Frequently Asked", testidPrefix = "faq" }) {
  if (!items?.length) return null;
  return (
    <section data-testid={`${testidPrefix}-section`} className="py-20 md:py-28 border-t border-white/5">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-10">
          <div className="md:col-span-5">
            <p className="overline">FAQs</p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl mt-4 leading-[1.05]">
              {title}
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 text-white/60 font-light leading-relaxed self-end">
            Still wondering? Here are the questions clients ask most. Don't see yours? Reach out and we'll answer personally within 24 hours.
          </p>
        </div>
        <Accordion type="single" collapsible className="border-t border-white/10">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`${testidPrefix}-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl py-6 hover:no-underline hover:text-[#D4AF37] data-[state=open]:text-[#D4AF37]">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 text-base font-light leading-relaxed pb-6">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
